import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/update/header.css";
import { useAppContext } from "../../context/AppContext";
// const apiUrl = process.env.REACT_APP_OPENAI_ENDPOINT;
import Chat from "../Chat";
export default function Header({
  aboutRef,
  portfolioRef,
  servicesRef,
  contactRef,
}) {
  const { theme, setTheme } = useAppContext();
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [modal, setModal] = useState(false);
  useEffect(() => {
    const handleScroll = debounce(() => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    }, 100); // Adjust debounce wait time as needed (in milliseconds)

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  };
  const scrollToSection = (element) => {
    window.scrollTo({
      top: element.current.offsetTop,
      behavior: "smooth",
    });
  };

  return (
    <div className="head-tabs">
      {showTopBtn && (
        <button
          className="top-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <span className="material-icons-outlined white-icon">
            keyboard_double_arrow_up
          </span>
        </button>
      )}
      <Chat />

      <div className="head-container">
        <div className="logo-wrap">
          <img
            src={require("../../assets/images/logo.png")}
            className="site-logo"
            alt="logo"
          />
        </div>

        {/* Desktop Nav */}
        <div className="tab-row hidden md:flex">
          <Link to={"/"}>
            <input
              type="button"
              className="tab-item"
              value="About ME"
              onClick={() => scrollToSection(aboutRef)}
            />
          </Link>
          <Link to={"/"}>
            <input
              type="button"
              className="tab-item"
              value="PORTFOLIO"
              onClick={() => scrollToSection(portfolioRef)}
            />
          </Link>
          <Link to={"/"}>
            <input
              type="button"
              className="tab-item"
              value="SERVICES"
              onClick={() => scrollToSection(servicesRef)}
            />
          </Link>
          <Link to={"/"}>
            <input
              type="button"
              className="tab-item"
              value="EXPERIENCE"
              onClick={() => scrollToSection(portfolioRef)}
            />
          </Link>
          <Link to={"/"}>
            <input
              type="button"
              className="tab-item"
              value="CONTACT"
              onClick={() => scrollToSection(contactRef)}
            />
          </Link>
        </div>

        {/* Theme toggle */}
        <div style={{ position: "relative" }} className="theme-wrap">
          <button
            onClick={() => setModal(!modal)}
            type="button"
            className="theme-btn"
          >
            {theme == "dark" ? (
              <MoonIcon
                fill={theme == "dark" ? "#fff" : "#000"}
                width={20}
                height={20}
              />
            ) : (
              <SunIcon width={20} height={20} />
            )}
          </button>
          {modal && (
            <div className="theme-menu">
              <ul className="">
                <li
                  className="flex item-center theme-btn-item"
                  onClick={() => {
                    setTheme("light");
                    setModal(false);
                  }}
                >
                  <SunIcon
                    fill={theme === "dark" ? "#fff" : "#000"}
                    theme={theme}
                    width={20}
                    height={20}
                  />
                  <p className="ml-4">Light</p>
                </li>
                <li
                  className="flex my-5 theme-btn-item"
                  onClick={() => {
                    setTheme("dark");
                    setModal(false);
                  }}
                >
                  <MoonIcon
                    fill={theme === "dark" ? "#fff" : "#000"}
                    theme={theme}
                    width={20}
                    height={20}
                  />
                  <p className="ml-4">Dark</p>
                </li>
                <li
                  className="flex theme-btn-item"
                  onClick={() => {
                    setTheme("system");
                    setModal(false);
                  }}
                >
                  <GearIcon
                    fill={theme === "dark" ? "#fff" : "#000"}
                    theme={theme}
                    width={20}
                    height={20}
                  />
                  <p className="ml-4">System</p>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Hamburger */}
      <button
        className="mobile-menu-btn md:hidden"
        onClick={() => setShowMobileMenu(!showMobileMenu)}
      >
        ☰
      </button>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar ${showMobileMenu ? "open" : ""}`}>
        <div className="mobile-nav">
          <button
            className="close-btn"
            onClick={() => setShowMobileMenu(false)}
          >
            ×
          </button>
          <Link
            to="/"
            onClick={() => {
              scrollToSection(aboutRef);
              setShowMobileMenu(false);
            }}
          >
            <span>About ME</span>
          </Link>
          <Link
            to="/"
            onClick={() => {
              scrollToSection(portfolioRef);
              setShowMobileMenu(false);
            }}
          >
            <span>PORTFOLIO</span>
          </Link>
          <Link
            to="/"
            onClick={() => {
              scrollToSection(servicesRef);
              setShowMobileMenu(false);
            }}
          >
            <span>SERVICES</span>
          </Link>
          <Link
            to="/"
            onClick={() => {
              scrollToSection(portfolioRef);
              setShowMobileMenu(false);
            }}
          >
            <span>EXPERIENCE</span>
          </Link>
          <Link
            to="/"
            onClick={() => {
              scrollToSection(contactRef);
              setShowMobileMenu(false);
            }}
          >
            <span>CONTACT</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

const MoonIcon = ({ width = 40, height = 40, fill = "#E3E3E3" }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="-1.43 -1.43 50.40 50.40"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M24.997,47.511C11.214,47.511,0,36.298,0,22.515C0,12.969,5.314,4.392,13.869,0.132 
            c0.385-0.191,0.848-0.117,1.151,0.186s0.381,0.766,0.192,1.15C13.651,4.64,12.86,8.05,12.86,11.601 
            c0,12.681,10.316,22.997,22.997,22.997c3.59,0,7.033-0.809,10.236-2.403c0.386-0.191,0.848-0.117,1.151,0.186 
            c0.304,0.303,0.381,0.766,0.192,1.15C43.196,42.153,34.597,47.511,24.997,47.511z 
            M12.248,3.372C5.862,7.608,2,14.709,2,22.515c0,12.68,10.316,22.996,22.997,22.996
            c7.854,0,14.981-3.898,19.207-10.343c-2.668,0.95-5.464,1.43-8.346,1.43 
            c-13.783,0-24.997-11.214-24.997-24.997C10.861,8.761,11.327,6.005,12.248,3.372z"
        />
      </g>
    </svg>
  );
};
const SunIcon = ({
  width = 40,
  height = 40,
  fill = "#121212",
  stroke = "#121212",
}) => {
  return (
    <svg
      fill={fill}
      height={height}
      width={width}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 64 64"
      enableBackground="new 0 0 64 64"
      xmlSpace="preserve"
      stroke="#121212"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g id="Sum">
          {" "}
          <path d="M17,31.9727993c0,8.295599,6.7157001,15.0206013,15,15.0206013s15-6.7250023,15-15.0206013 c0-8.2957001-6.7157021-15.0206985-15-15.0206985S17,23.6770992,17,31.9727993z M45,31.9727993 c0,7.1779995-5.8317986,13.0178013-13,13.0178013c-7.1681843,0-13-5.8398018-13-13.0178013 c0-7.1780987,5.8318157-13.0178986,13-13.0178986C39.1682014,18.9549007,45,24.7947006,45,31.9727993z"></path>{" "}
          <path d="M32.7421989,11.7700996c0.5527,0,1-0.4478998,1-1.0014V1.0014c0-0.5535-0.4473-1.0014-1-1.0014 c-0.5527992,0-0.9999981,0.4479-0.9999981,1.0014v9.7672997C31.7422009,11.3221998,32.1893997,11.7700996,32.7421989,11.7700996z"></path>{" "}
          <path d="M48.6445007,4.6588001C48.1640015,4.3790998,47.5527,4.5443001,47.2783012,5.0235l-4.8838005,8.4578991 c-0.2773018,0.4792004-0.1133003,1.0914001,0.364315,1.3681002c0.1581841,0.0918999,0.3300858,0.1350002,0.5,0.1350002 c0.3456841,0,0.6815834-0.1789999,0.8661842-0.4996996l4.8838158-8.4580002 C49.2860985,5.5476999,49.1221008,4.9355001,48.6445007,4.6588001z"></path>{" "}
          <path d="M50.7616997,23.0286999c0.1689987,0,0.3408012-0.0429993,0.4990005-0.1340008l8.4580002-4.8835983 c0.4776001-0.2758007,0.6425972-0.8889008,0.3661995-1.3681011c-0.2763023-0.4771996-0.8837013-0.6434994-1.3661995-0.3666992 l-8.4580002,4.8836002c-0.4775009,0.2757988-0.6425018,0.8889999-0.3661995,1.3680992 C50.0790977,22.8488007,50.4160004,23.0286999,50.7616997,23.0286999z"></path>{" "}
          <path d="M11.7676001,32.7421989c0-0.5533981-0.4473-1.0012989-0.999999-1.0012989H1.0000008c-0.5527,0-1,0.4479008-1,1.0012989 c0,0.5535011,0.4473,1.0014,1,1.0014h9.7676001C11.3203001,33.7435989,11.7676001,33.2957001,11.7676001,32.7421989z"></path>{" "}
          <path d="M4.2822008,18.0111008L12.7402,22.8946991c0.1582003,0.0910015,0.3291006,0.1340008,0.4990005,0.1340008 c0.3457003,0,0.6827002-0.1798992,0.8671999-0.5007c0.2764149-0.4790993,0.1114149-1.0923004-0.3662004-1.3680992 l-8.4579992-4.8836002c-0.4813852-0.2768002-1.0918002-0.1125011-1.3662002,0.3666992 C3.6396008,17.1222,3.8047006,17.7353001,4.2822008,18.0111008z"></path>{" "}
          <path d="M20.7411995,14.9844999c0.1699009,0,0.3418007-0.0431004,0.4990005-0.1339998 c0.4785004-0.2777004,0.6426163-0.8899002,0.3661995-1.3681002l-4.8827991-8.4579 c-0.2772999-0.4801998-0.8895998-0.6444001-1.3661995-0.3666997c-0.4785004,0.2776999-0.6425858,0.8898997-0.3662004,1.3680997 l4.8828001,8.4579C20.0596008,14.8055,20.3955002,14.9844999,20.7411995,14.9844999z"></path>{" "}
          <path d="M32.7421989,52.2318993c-0.5527992,0-0.9999981,0.4478989-0.9999981,1.0014V62.9986 c0,0.5535011,0.4471989,1.0014,0.9999981,1.0014c0.5527,0,1-0.4478989,1-1.0014v-9.7653008 C33.7421989,52.6797981,33.294899,52.2318993,32.7421989,52.2318993z"></path>{" "}
          <path d="M22.5272999,49.8936996c-0.4813995-0.2795982-1.0907993-0.114399-1.3661995,0.3647995l-4.8838005,8.457901 C16,59.1955986,16.1639996,59.8077011,16.6415997,60.0844994c0.1582165,0.0918999,0.330101,0.1348991,0.5,0.1348991 c0.3457012,0,0.6816006-0.1788979,0.8662167-0.4996986l4.8837833-8.457901 C23.1688995,50.7826004,23.0049,50.1705017,22.5272999,49.8936996z"></path>{" "}
          <path d="M13.4824009,42.3922005l-8.4580002,4.8837013c-0.4775,0.2756996-0.6425853,0.8888969-0.3662,1.3680992 c0.1846147,0.3206978,0.5215001,0.5006981,0.8671999,0.5006981c0.1689,0,0.3407998-0.0430984,0.4990001-0.1339989 l8.4580002-4.8837013c0.4775-0.2756996,0.6425991-0.8889008,0.3661995-1.3680992 C14.5732002,42.2807007,13.9639006,42.1144981,13.4824009,42.3922005z"></path>{" "}
          <path d="M63,31.7409h-9.7656021c-0.5527992,0-1,0.4479008-1,1.0012989c0,0.5535011,0.4472008,1.0014,1,1.0014H63 c0.5527,0,1-0.4478989,1-1.0014C64,32.1888008,63.5527,31.7409,63,31.7409z"></path>{" "}
          <path d="M58.9756012,47.2759018l-8.4580002-4.8837013c-0.4805031-0.2766991-1.0917854-0.1114998-1.3662033,0.3666992 c-0.2763977,0.4791985-0.1113968,1.0923996,0.3662033,1.3680992l8.4580002,4.8837013 c0.1582146,0.0909004,0.3290977,0.1339989,0.4989967,0.1339989c0.3457031,0,0.6826019-0.1800003,0.867218-0.5006981 C59.6181984,48.1647987,59.4530983,47.5516014,58.9756012,47.2759018z"></path>{" "}
          <path d="M42.8378983,50.2584991c-0.2753983-0.4791985-0.8866997-0.6443977-1.3661995-0.3647995 c-0.4776001,0.2768021-0.6415977,0.8889008-0.3642998,1.3680992l4.8838005,8.457901 c0.1846161,0.3208008,0.5205002,0.4996986,0.8661995,0.4996986c0.169899,0,0.3418007-0.0429993,0.5-0.1348991 c0.4775009-0.2767982,0.6416016-0.8889008,0.3642998-1.3680992L42.8378983,50.2584991z"></path>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

const GearIcon = ({ width = 200, height = 200, fill = "#000" }) => {
  return (
    <svg
      fill={fill}
      height={height}
      width={width}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 54 54"
      xmlSpace="preserve"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M51.22,21h-5.052c-0.812,0-1.481-0.447-1.792-1.197s-0.153-1.54,0.42-2.114l3.572-3.571 c0.525-0.525,0.814-1.224,0.814-1.966c0-0.743-0.289-1.441-0.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933,0l-3.571,3.571 c-0.574,0.573-1.366,0.733-2.114,0.421C33.447,9.313,33,8.644,33,7.832V2.78C33,1.247,31.753,0,30.22,0H23.78 C22.247,0,21,1.247,21,2.78v5.052c0,0.812-0.447,1.481-1.197,1.792c-0.748,0.313-1.54,0.152-2.114-0.421l-3.571-3.571 c-1.052-1.052-2.883-1.05-3.933,0l-4.553,4.553c-0.525,0.525-0.814,1.224-0.814,1.967c0,0.742,0.289,1.44,0.814,1.966l3.572,3.571 c0.573,0.574,0.73,1.364,0.42,2.114S8.644,21,7.832,21H2.78C1.247,21,0,22.247,0,23.78v6.439C0,31.753,1.247,33,2.78,33h5.052 c0.812,0,1.481,0.447,1.792,1.197s0.153,1.54-0.42,2.114l-3.572,3.571c-0.525,0.525-0.814,1.224-0.814,1.966 c0,0.743,0.289,1.441,0.814,1.967l4.553,4.553c1.051,1.051,2.881,1.053,3.933,0l3.571-3.572c0.574-0.573,1.363-0.731,2.114-0.42 c0.75,0.311,1.197,0.98,1.197,1.792v5.052c0,1.533,1.247,2.78,2.78,2.78h6.439c1.533,0,2.78-1.247,2.78-2.78v-5.052 c0-0.812,0.447-1.481,1.197-1.792c0.751-0.312,1.54-0.153,2.114,0.42l3.571,3.572c1.052,1.052,2.883,1.05,3.933,0l4.553-4.553 c0.525-0.525,0.814-1.224,0.814-1.967c0-0.742-0.289-1.44-0.814-1.966l-3.572-3.571c-0.573-0.574-0.73-1.364-0.42-2.114 S45.356,33,46.168,33h5.052c1.533,0,2.78-1.247,2.78-2.78V23.78C54,22.247,52.753,21,51.22,21z M52,30.22 C52,30.65,51.65,31,51.22,31h-5.052c-1.624,0-3.019,0.932-3.64,2.432c-0.622,1.5-0.295,3.146,0.854,4.294l3.572,3.571 c0.305,0.305,0.305,0.8,0,1.104l-4.553,4.553c-0.304,0.304-0.799,0.306-1.104,0l-3.571-3.572c-1.149-1.149-2.794-1.474-4.294-0.854 c-1.5,0.621-2.432,2.016-2.432,3.64v5.052C31,51.65,30.65,52,30.22,52H23.78C23.35,52,23,51.65,23,51.22v-5.052 c0-1.624-0.932-3.019-2.432-3.64c-0.503-0.209-1.021-0.311-1.533-0.311c-1.014,0-1.997,0.4-2.761,1.164l-3.571,3.572 c-0.306,0.306-0.801,0.304-1.104,0l-4.553-4.553c-0.305-0.305-0.305-0.8,0-1.104l3.572-3.571c1.148-1.148,1.476-2.794,0.854-4.294 C10.851,31.932,9.456,31,7.832,31H2.78C2.35,31,2,30.65,2,30.22V23.78C2,23.35,2.35,23,2.78,23h5.052 c1.624,0,3.019-0.932,3.64-2.432c0.622-1.5,0.295-3.146-0.854-4.294l-3.572-3.571c-0.305-0.305-0.305-0.8,0-1.104l4.553-4.553 c0.304-0.305,0.799-0.305,1.104,0l3.571,3.571c1.147,1.147,2.792,1.476,4.294,0.854C22.068,10.851,23,9.456,23,7.832V2.78 C23,2.35,23.35,2,23.78,2h6.439C30.65,2,31,2.35,31,2.78v5.052c0,1.624,0.932,3.019,2.432,3.64 c1.502,0.622,3.146,0.294,4.294-0.854l3.571-3.571c0.306-0.305,0.801-0.305,1.104,0l4.553,4.553c0.305,0.305,0.305,0.8,0,1.104 l-3.572,3.571c-1.148,1.148-1.476,2.794-0.854,4.294c0.621,1.5,2.016,2.432,3.64,2.432h5.052C51.65,23,52,23.35,52,23.78V30.22z"></path>{" "}
          <path d="M27,18c-4.963,0-9,4.037-9,9s4.037,9,9,9s9-4.037,9-9S31.963,18,27,18z M27,34c-3.859,0-7-3.141-7-7s3.141-7,7-7 s7,3.141,7,7S30.859,34,27,34z"></path>
        </g>{" "}
      </g>
    </svg>
  );
};
